import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
const main = () => import("@/components/main"); //导航栏
const home = () => import("@/components/home"); //首页内容 展示业绩

const login = () => import("@/components/login"); //登录

const error = () => import("@/components/error"); //错误


Vue.use(Router)

import baseM from './routes/base.js';
import transport from './routes/transbusi.js';
import transfh from './routes/transfh.js';
import carManagement from './routes/car.js';
import finance from './routes/finance.js';
import carstore from './routes/store.js';
import sellcar from './routes/sellcar.js';
import xz from './routes/xingzhen.js';
import renshi from './routes/personnel.js';
import legalaffirs from './routes/legalaffairs.js';
import transhort from './routes/transdtys.js';

import study from './routes/study.js';

// history: false,
// hashbang: true,
const router = new Router({
	mode: "history",
	// base: getAbsolutePath(),
	routes: [{
			// 首先进行重定向操作
			path: "/",
			redirect: "/login"
		},
		{
			name: "login",
			path: "/login",
			component: login,
			meta: {
				keepAlive: false, // 不需要被缓存
				title: "登录",
				content: "",
				description: ""
			}
		},
		{
			name: "error",
			path: "/error",
			component: error,
			meta: {
				keepAlive: false, // 不需要被缓存
				title: "错误",
				content: "",
				description: ""
			}
		},
		{
			name: "main",
			path: "/main",
			component: main,
			meta: {
				title: "物流管理运输通用版",
				content: "",
				description: ""
			},
			children: [{
					path: "/home",
					name: "Home",
					component: home,
					meta: {
						requiresAuth: true,
						keepAlive: true, // 不需要被缓存
						title: "首页"
					}
				},
				//基础菜单////////////////
				...baseM,
				//运输管理-配货//////////////////////
				...transport,
				//运输管理-发货//////////////////////
				...transfh,
				//车辆管理//////////////////////
				...carManagement,
				//财务管理//////////////////////
				...finance,
				//财务管理//////////////////////
				...carstore,
				//销售管理//////////////////////
				...sellcar,
				//行政管理//////////////////////
				...xz,
				//人事管理//////////////////////
				...renshi,
				//人事管理//////////////////////
				...legalaffirs,
				///短途运输登记
				...transhort,
				///培训学习资料
				...study

			]
		},
		{
			path: "*",
			component: login
		}
	]
});

// 解决重复点击导航路由报错
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err);
}


// 根据路径名称动态匹配，非根路径时使用
function getAbsolutePath() {
	let path = location.pathname;
	return path.substring(0, path.lastIndexOf("/") + 1);
}

// 全局路由守卫
router.beforeEach((to, from, next) => {
	// console.log("navigation-guards");
	// to: Route: 即将要进入的目标 路由对象
	// from: Route: 当前导航正要离开的路由
	// next: Function: 一定要调用该方法来 resolve 这个钩子。执行效果依赖 next 方法的调用参数。
	// console.log(to);
	// console.log(from);
	document.title = to.meta.title || "Unknow title";
	let head = document.getElementsByTagName("head");
	let meta = document.createElement("meta");
	meta.content = "郝军的工作台" || "Unknow keywords";
	head[0].appendChild(meta);

	let meta2 = document.createElement("meta");
	meta2.content = "郝军的工作台 关键字" || "Unknow keywords";
	head[0].appendChild(meta2);
	// document.querySelector('meta[name="keywords"]').setAttribute('content', 'keywords');
	// document.querySelector('meta[name="description"]').setAttribute('content', 'description');

	// const nextRoute = ['home', 'good-list', 'good-detail', 'cart', 'profile'];
	// let isLogin = global.isLogin;  // 是否登录
	// // 未登录状态；当路由到nextRoute指定页时，跳转至login
	// if (nextRoute.indexOf(to.name) >= 0) {
	//   if (!isLogin) {
	//     console.log('what fuck');
	//     router.push({ name: 'login' })
	//   }
	// }
	// // 已登录状态；当路由到login时，跳转至home
	// if (to.name === 'login') {
	//   if (isLogin) {
	//     router.push({ name: 'home' });
	//   }
	// }
	next();
});

export default router;